import React, { useEffect, useState } from 'react';
import { FilterMenu, Tooltip, TooltipButton } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import { useEnhancedDataTableContext } from '../EnhancedDataTableContext';

const FilterComponent = React.memo((props) => {
  const context = useEnhancedDataTableContext();

  const { headers, tableNm, showFilter } = context;
  const filterCnt = headers.filter((h) => h?.filter !== '').length;

  const [showFilterState, setShowFilterState] = useState(showFilter);
  const { onFilterClicked, setItemActionClicked } = props;

  const handleFilterClick = () => {
    setShowFilterState(!showFilterState);
    onFilterClicked(!showFilterState);
    setItemActionClicked(false);
  };

  useEffect(() => {
    setShowFilterState(showFilter);
  }, [showFilter]);

  return (
    <div id={`${tableNm}-table-filter-component`} style={{ display: 'inline-block', marginRight: '10px' }}>
      <Tooltip
        id={`${tableNm}-table-filter-button-tooltip`}
        triggerElement={(
          <TooltipButton
            id={`${tableNm}-table-filter-button`}
            icon={(
              <FilterMenu
                id={`${tableNm}-table-share-button-filterMenu`}
                onFilterButtonClick={handleFilterClick}
                filtersApplied={filterCnt}
              />
)}
          />
                )}
        placement="top"
        forcePlacement={true}
      >Filter
      </Tooltip>
    </div>
  );
});

FilterComponent.displayName = 'FilterComponent';

FilterComponent.propTypes = {
  onFilterClicked: PropTypes.func.isRequired,
  setItemActionClicked: PropTypes.func,
};

export default FilterComponent;
